// in src/MyLoginPage.js
import * as React from 'react';
import { useState } from 'react';
import { useLogin } from 'react-admin';

import styles from './LoginPage.module.css';

const MyLoginPage = () => {
  const login = useLogin();

  const [visible, setVisble] = useState(false)
  const [errors, setErrors] = useState({ message: '' })
  const [values, setValues] = useState({
    username: '',
    password: ''
  })

  return (
    <div className={styles.app}>
      <div>
        <form className={styles.form} onSubmit={handleSubmit} noValidate>

          <div className={styles.appHeader}>
            <img src='images/digible_logo.png' className={styles.appLogo} alt='logo' />
          </div>

          <div className={styles.formInputs}>
            <label htmlFor='username' className={styles.formLabel}>User Name</label>
            <input id='username'
              name='username'
              className={styles.formInput}
              placeholder='User Name'
              value={values.username}
              onChange={handleChanges}
            />
          </div>

          <div className={styles.formInputs}>
            <label htmlFor='password' className={styles.formLabel}>Password</label>
            <input id='password'
              type={visible ? 'text' : 'password'}
              name='password'
              className={styles.formInput}
              placeholder='Password'
              value={values.password}
              onChange={handleChanges}
            />
          </div>

          <div className={styles.iconTouch} onClick={() => setVisble(!visible)}>
            <p>{visible ? 'Hide password' : 'Show password'}</p>
            <img src={visible ? 'icons/visibility.png' : 'icons/invisible.png'}
              alt='eye' className={styles.iconStyle}
            />
          </div>

          <button className={styles.formInputBtn} type='submit'>SIGN IN</button>

          {errors.message &&
            <div className={styles.erroBox}>
              <p>{errors.message}</p>
            </div>
          }
        </form>
      </div>
    </div>
  );

  function handleChanges(e) {
    const { name, value } = e.target
    setErrors({ message: '' })
    setValues({
      ...values,
      [name]: value
    })
  }

  async function handleSubmit(e) {
    e.preventDefault()
    login(values).catch(() =>
      setErrors({message: 'Invalid email or password'})
    );
  }
};

export default MyLoginPage;